import React, { useRef, useEffect } from 'react';
import { useMapContext } from '@/contexts/MapContext';

interface MapComponentProps {
  center: { lat: number; lng: number };
  zoom: number;
}

const MapComponent: React.FC<MapComponentProps> = ({ center, zoom }) => {
  const mapRef = useRef<HTMLDivElement>(null);
  const { initMap, isMapInitialized } = useMapContext();

  useEffect(() => {
    if (mapRef.current && !isMapInitialized) {
      initMap(mapRef.current, center, zoom);
    }
  }, [initMap, center, zoom, isMapInitialized]);

  return <div ref={mapRef} style={{ width: '100%', height: '700px' }} />;
};

export default MapComponent;